import React from 'react';
import Icon from '../../../components/AppIcon';

const RiskMetricsCard = ({ 
  title, 
  value, 
  unit = '', 
  threshold, 
  icon, 
  trend = null,
  alertLevel = 'normal' // normal, warning, critical
}) => {
  const getAlertColor = () => {
    switch (alertLevel) {
      case 'critical': return 'border-red-500 bg-red-50 dark:bg-red-950';
      case 'warning': return 'border-amber-500 bg-amber-50 dark:bg-amber-950';
      default: return 'border-border bg-card';
    }
  };

  const getValueColor = () => {
    switch (alertLevel) {
      case 'critical': return 'text-red-600 dark:text-red-400';
      case 'warning': return 'text-amber-600 dark:text-amber-400';
      default: return 'text-foreground';
    }
  };

  const getTrendIcon = () => {
    if (!trend) return null;
    return trend > 0 ? 'TrendingUp' : 'TrendingDown';
  };

  const getTrendColor = () => {
    if (!trend) return '';
    return trend > 0 ? 'text-green-600 dark:text-green-400' : 'text-red-600 dark:text-red-400';
  };

  return (
    <div className={`p-6 rounded-lg border-2 transition-all duration-200 ${getAlertColor()}`}>
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center space-x-2">
          <Icon name={icon} size={20} className="text-muted-foreground" />
          <h3 className="text-sm font-medium text-muted-foreground">{title}</h3>
        </div>
        {alertLevel !== 'normal' && (
          <div className="flex items-center">
            <Icon 
              name="AlertTriangle" 
              size={16} 
              className={alertLevel === 'critical' ? 'text-red-500' : 'text-amber-500'} 
            />
          </div>
        )}
      </div>
      <div className="space-y-2">
        <div className="flex items-baseline space-x-2">
          <span className={`text-2xl font-bold font-mono ${getValueColor()}`}>
            {value}
          </span>
          {unit && (
            <span className="text-sm text-muted-foreground">{unit}</span>
          )}
          {trend !== null && (
            <div className={`flex items-center space-x-1 ${getTrendColor()}`}>
              <Icon name={getTrendIcon()} size={14} />
              <span className="text-xs font-medium">
                {Math.abs(trend)?.toFixed(1)}%
              </span>
            </div>
          )}
        </div>
        
        {threshold && (
          <div className="text-xs text-muted-foreground">
            Threshold: {threshold}
          </div>
        )}
      </div>
    </div>
  );
};

export default RiskMetricsCard;